import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import * as Yup from "yup";

const InvoiceListTraining = () => {
  // State for form inputs

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Invoice List (Training)"));
  }, [dispatch]);
  useEffect(() => {
    fetchData();
    fetchInvoiceData();

  }, []);

  const intialFormData = {
    ProjectTrainingsInvoicePayment: {
      ID: "",
      TXNName: "",
      TXNDate: "",
      ExecutiveID: "",
      InvoiceDate: "",
      InvoiceNo: "",
      RevisionNumber: "",
    },
  }
  const [formData, setFormData] = useState(intialFormData);

  // State for grid lines
  const [gridLines, setGridLines] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(true);


  const [apiStatus, setApiStatus] = useState(undefined)
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-training-invoice?P_ClientID&P_ProjectID&P_EmployeeID`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status)

        setGridLines(
          response?.data?.data?.map(item => ({
            ...item,
            Remarks: "",
                ExchangeRate: 1,
            FollowUpDate: moment().format("DD-MMM-YYYY"),
            InvoiceDate: moment().format("DD-MMM-YYYY"),
            PaymentDueDate: moment().add(item.PaymentTermDays, "days").format("DD-MMM-YYYY")
          }))
        );

      }
    } catch (error) {
      console.error("Error Fetching the Api ", error);
    } finally {
      setLoading(false);
    }
  };



  const fetchInvoiceData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/training-invoice-getdata`
      );
      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        // Client Option
        const clientOpt = cleanedData?.clientlist?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setClientOptions(clientOpt);
        // Project Option
        const projectOpt = cleanedData?.projectlist?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setProjectOptions(projectOpt);
        // Employee Option
        const empOpt = cleanedData?.employeelist?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmployeeOptions(empOpt);
      }
    } catch (error) {
      console.error("Error Fetching the Api ", error);
    }
  };


  // Handle get data click
  const handleGetDataClick = async () => {
    const payload = {
      clientId: selectedClient?.value || "",
      projectId: selectedProject?.value || "",
      employeeId: selectedEmployee?.value || "",
    };

    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-training-invoice?P_ClientID=${payload.clientId}&P_ProjectID=${payload.projectId}&P_EmployeeID=${payload.employeeId}`
      );
      if (response?.status === 200) {
        setGridLines(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit = async () => {
    try {
      // Get rows where IsConfirmed is true
      const checkedRows = gridLines.filter((line) => line.IsConfirmed);

      if (checkedRows.length === 0) {
        toast.error("Please select at least one row to submit");
        return;
      }

      // Validate each checked row with the full schema
      for (let row of checkedRows) {
        try {
          await schema.validate(row, { abortEarly: false });
        } catch (validationError) {
          console.error("Validation error for row:", row, validationError);
          const errorMsg = validationError.errors?.[0] || "Validation failed";
          toast.error(errorMsg);
          return;
        }
      }

      // Prepare the payload
      const submitData = {
        lines: checkedRows.map((line) => ({
          ...line,
          IsConfirmed: line.IsConfirmed ? 1 : 0,
        })),
      };
      console.log("submitData", submitData);

      setLoading(true);
      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/project-training-invoice`,
        submitData,
        "post"
      );

      if (response?.status === 200) {
        toast.success("Data submitted successfully!");
        fetchData();
      } else {
        throw new Error(response?.data?.message || "Failed to submit data");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "An error occurred while submitting data.");
    } finally {
      setLoading(false);
    }
  };


  const schema = Yup.object().shape({
    IsConfirmed: Yup.boolean(),

    ClientID: Yup.string().nullable(),
    ProjectID: Yup.string().nullable(),
    EmployeeID: Yup.string().nullable(),
    PresentDays: Yup.string().nullable(),
    WorkingDays: Yup.string().nullable(),
    InvoiceAmount: Yup.string().nullable(),
    InvoicedDays: Yup.string().nullable(),
    InvoicedAmount: Yup.string().nullable(),
    TaxPercent: Yup.string().nullable(),
    ProjectInvoiceDetailID: Yup.string().nullable(),

    // Conditionally require ExchangeRate when IsConfirmed is true
    ExchangeRate: Yup.string().when('IsConfirmed', {
      is: true,
      then: (schema) => schema.required("Exchange Rate is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    InvoiceBasedOn_236: Yup.string().nullable(),

    // Conditionally require InvoiceNo when IsConfirmed is true
    InvoiceNo: Yup.string().when('IsConfirmed', {
      is: true,
      then: (schema) => schema.required("Invoice No is required"),
      otherwise: (schema) => schema.nullable(),
    }),

    BasicAmount: Yup.string().nullable(),
    InvoiceDate: Yup.string().nullable(),
    StartDate: Yup.string().nullable(),
    EndDate: Yup.string().nullable(),
    InvoiceFromDate: Yup.string().nullable(),
    InvoiceToDate: Yup.string().nullable(),
    PaymentDueDate: Yup.string().nullable(),
    FollowUpDate: Yup.string().nullable(),
    PaymentReceivedDate: Yup.string().nullable(),
    OverDueDays: Yup.string().nullable(),
    DayCount: Yup.string().nullable(),
    InvoiceRate: Yup.string().nullable(),
    OverDueAmount: Yup.string().nullable(),
    AdjustmentAmount: Yup.string().nullable(),
    PaymentTermDays: Yup.string().nullable(),
    IsTnEInvoiceDone: Yup.string().nullable(),
    IncentiveGenerated: Yup.string().nullable(),
    InvoiceCalculatedAmount: Yup.string().nullable(),
    Remarks: Yup.string().nullable(),
  });

  // CALCULATION LOGIC MODULE

  /**
   * Main calculation functions
   */
  const CalculationLogic = {
    /**
     * Calculate basic amount based on working days and rate type
     * @param {object} line - The invoice line item
     * @returns {object} Updated line with BasicAmount
     */
    calculateBasicAmount: (line) => {
      const invoiceRate = Number(line.InvoiceRate) || 0;
      const dayCount = Number(line.DayCount) || 0;
      let basicAmount = 0;

      switch (Number(line.InvoiceBasedOn_236)) {
        case 1530: // Hourly rate (8 hours/day)
          basicAmount = invoiceRate * 8 * dayCount;
          break;
        case 1531: // Daily rate
          basicAmount = invoiceRate * dayCount;
          break;
        default:
          basicAmount = 0;
      }

      return {
        ...line,
        BasicAmount: basicAmount.toFixed(2)
      };
    },

    /**
     * Calculate invoiced amount based on days and adjustments
     * @param {object} line - The invoice line item
     * @returns {object} Updated line with InvoicedAmount
     */
    calculateInvoicedAmount: (line) => {
      const invoiceRate = Number(line.InvoiceRate) || 0;
      const invoicedDays = Number(line.InvoicedDays) || 0;
      const adjustment = Number(line.AdjustmentAmount) || 0;
      const basicAmount = Number(line.BasicAmount) || 0;
      let invoicedAmount = 0;

      if (invoicedDays > 0) {
        switch (Number(line.InvoiceBasedOn_236)) {
          case 1530: // Hourly
            invoicedAmount = invoiceRate * 8 * invoicedDays + adjustment;
            break;
          case 1531: // Daily
            invoicedAmount = invoiceRate * invoicedDays + adjustment;
            break;
          default:
            invoicedAmount = basicAmount + adjustment;
        }
      } else {
        invoicedAmount = basicAmount + adjustment;
      }

      return {
        ...line,
        InvoicedAmount: invoicedAmount.toFixed(2)
      };
    },

    /**
     * Calculate tax amount
     * @param {object} line - The invoice line item
     * @returns {object} Updated line with TaxAmount
     */
    calculateTax: (line) => {
      const baseAmount = Number(line.InvoicedAmount) || Number(line.BasicAmount) || 0;
      const taxPercent = Number(line.TaxPercent) || 0;
      const taxAmount = (baseAmount * taxPercent) / 100;

      return {
        ...line,
        TaxAmount: taxAmount.toFixed(2)
      };
    },

    /**
     * Calculate final amount with exchange rate conversion
     * @param {object} line - The invoice line item
     * @returns {object} Updated line with InvoiceCalculatedAmount
     */
    calculateFinalAmount: (line) => {
      const baseAmount = Number(line.InvoicedAmount) || Number(line.BasicAmount) || 0;
      const taxPercent = Number(line.TaxPercent) || 0;
      const exchangeRate = Number(line.ExchangeRate) || 1; // Default to 1 if 0/invalid
      const InvoicedDays = Number(line.InvoicedDays)
      const taxAmount = (baseAmount * taxPercent) / 100;
      let calculatedAmount = 0;

      if (exchangeRate > 0) {
        calculatedAmount = (baseAmount + taxAmount) * exchangeRate;
      } else {
        calculatedAmount = line.FixedBid === 1 ? 0 : baseAmount + taxAmount;
      }
      if (InvoicedDays > 0) {
        calculatedAmount = (baseAmount + taxAmount) * exchangeRate;
      } else {
        calculatedAmount = (baseAmount + taxAmount) * exchangeRate * InvoicedDays;
      }



      return {
        ...line,
        InvoiceCalculatedAmount: calculatedAmount.toFixed(2),
        TaxAmount: taxAmount.toFixed(2)
      };
    },

    /**
     * Calculate payment due date and overdue days
     * @param {object} line - The invoice line item
     * @returns {object} Updated line with PaymentDueDate and OverDueDays
     */
    calculatePaymentDates: (line) => {
      if (!line.InvoiceDate) return line;

      const dueDate = moment(line.InvoiceDate, "DD-MM-YYYY")
        .add(line.PaymentTermDays || 0, "days")
        .format("DD-MM-YYYY");

      let overdueDays = line.OverDueDays || 0;

      if (!line.PaymentReceivedDate) {
        const today = moment();
        const dueDateMoment = moment(dueDate, "DD-MM-YYYY");

        if (today.isAfter(dueDateMoment)) {
          overdueDays = today.diff(dueDateMoment, "days");
        }
      }

      return {
        ...line,
        PaymentDueDate: dueDate,
        OverDueDays: overdueDays
      };
    }
  };

  // LINE ITEM HANDLERS

  const handleLineChange = (index, field, value) => {
    const updatedLines = [...gridLines];
    updatedLines[index] = { ...updatedLines[index], [field]: value };
    const currentLine = updatedLines[index];

    // Handle field-specific calculations
    switch (field) {
      case "DayCount":
        updatedLines[index] = CalculationLogic.calculateBasicAmount(currentLine);
        updatedLines[index] = CalculationLogic.calculateFinalAmount(updatedLines[index]);
        break;

      case "InvoicedDays":
      case "AdjustmentAmount":
        updatedLines[index] = CalculationLogic.calculateInvoicedAmount(currentLine);
        updatedLines[index] = CalculationLogic.calculateFinalAmount(updatedLines[index]);
        break;

      case "TaxPercent":
        updatedLines[index] = CalculationLogic.calculateFinalAmount(currentLine);
        break;

      case "ExchangeRate":
        updatedLines[index] = CalculationLogic.calculateFinalAmount(currentLine);

        if (currentLine.Consolidated === 1) {
          updatedLines.forEach((row, idx) => {
            if (row.Consolidated === 1 &&
              row.ClientID === currentLine.ClientID &&
              row.ProjectID === currentLine.ProjectID) {
              updatedLines[idx] = {
                ...row,
                ExchangeRate: value,
                ...CalculationLogic.calculateFinalAmount({ ...row, ExchangeRate: value })
              };
            }
          });
        }
        setGridLines(updatedLines);
        return;

      case "PaymentReceivedDate":
        updatedLines[index] = {
          ...currentLine,
          OverDueDays: value ? 0 : currentLine.OverDueDays
        };
        break;

      case "InvoiceNo":
        if (currentLine.Consolidated === 1) {
          updatedLines.forEach((row, idx) => {
            if (row.Consolidated === 1 &&
              row.ClientID === currentLine.ClientID &&
              row.ProjectID === currentLine.ProjectID) {
              updatedLines[idx] = { ...row, InvoiceNo: value };
            }
          });
        }
        setGridLines(updatedLines);
        return;

      case "InvoiceDate":
        updatedLines[index] = CalculationLogic.calculatePaymentDates(currentLine);
        break;

      case "IsConfirmed":
        // No calculations needed
        break;
    }

    setGridLines(updatedLines);
  };

  // INITIALIZATION AND UTILITIES

  // Initialize with default values if needed
  const initializeLineCalculations = (line) => {
    let updatedLine = CalculationLogic.calculateBasicAmount(line);
    updatedLine = CalculationLogic.calculateInvoicedAmount(updatedLine);
    updatedLine = CalculationLogic.calculateFinalAmount(updatedLine);
    return CalculationLogic.calculatePaymentDates(updatedLine);
  };

  // Helper functions
  const isFixedBid = (line) => line.FixedBid === 1;
  const isConsolidated = (line) => line.Consolidated === 1;

  const rootClass = (line) => `tr-parent-blue treegrid-C${line.ClientID}`;
  const parentClass = (line) =>
    `td-child-light-blue treegrid-P${line.ProjectID} treegrid-parent-C${line.ClientID}`;
  const leafParentClass = (line) =>
    `treegrid-L${line.LineNo} treegrid-parent-P${line.ProjectID}`;

  // Filtered entries for display
  const filteredEntries = gridLines.filter((item) => item.RowState !== 437);

  const customIndicator = {
    display: "inline-block",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginBottom: "0px",
    verticalAlign: "middle",
    marginLeft: "10px",
    marginRight: "3px",
    boxShadow:
      "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
    border: "solid 2px #fff",
  };

  const CustomDatePickerInput = React.forwardRef(
    ({ value, onClick, width = "100px" }, ref) => (
      <div>
        <input
          type="text"
          value={value}
          onClick={onClick}
          ref={ref}
          readOnly
          style={{ width, cursor: "pointer" }}
        />
      </div>
    )
  );

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <form>
            <div className="row">
              <div className="col-md-2">
                <label><b>Client</b></label>
                <Select
                  classNamePrefix="select-sm" // Add this
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "25px",
                      height: "35px",
                    }),
                  }}
                  options={[{ value: null, label: "Select" }, ...clientOptions]}
                  value={selectedClient}
                  onChange={(option) => setSelectedClient(option)}
                  isClearable={true}
                  placeholder="Select Client"
                />
              </div>
              <div className="col-md-2">
                <label><b>Project</b></label>
                <Select
                  classNamePrefix="select-sm" // Add this
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "25px",
                      height: "35px",
                    }),
                  }}
                  options={projectOptions}
                  value={selectedProject}
                  onChange={(option) => setSelectedProject(option)}
                  isClearable={true}
                  placeholder="Select Project"
                />
              </div>
              <div className="col-md-2">
                <label><b>Employee</b></label>
                <Select
                  classNamePrefix="select-sm" // Add this
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "25px",
                      height: "35px",
                    }),
                  }}
                  options={employeeOptions}
                  value={selectedEmployee}
                  onChange={(option) => setSelectedEmployee(option)}
                  isClearable={true}
                  placeholder="Select Employee"
                />
              </div>

              <div className="col-md-6 mt-3 text-end">
                <button
                  type="button"
                  onClick={() => {
                    setSelectedClient(null);
                    setSelectedProject(null);
                    setSelectedEmployee(null);
                    fetchData();
                  }}
                  className="custom-btn me-2 mt-2"
                >
                  Reset
                </button>
                <button
                  type="button"
                  onClick={handleGetDataClick}
                  className="custom-btn me-2 mt-2"
                >
                  Get Data
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="custom-btn mt-2"
                >
                  Submit
                </button>
              </div>
            </div>

            <br />

            <div className="mb-1 d-flex align-items-center">
              <div>{filteredEntries.length} Invoice Details</div>
              <p style={{ ...customIndicator, background: "#bad893" }}></p>
              <span className="me-3">FixedBid</span>
              <p style={{ ...customIndicator, background: "#ffe4a4" }}></p>
              <span>Consolidated</span>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div style={{ overflowX: "auto" }} className="p-0 m-0">
                  <div className="col-md-12">
                    <table
                      class="table table-bordered"
                      style={{ minWidth: "1600px" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan="4" class="sub-header"></th>
                          <th colSpan="12" class="sub-header">
                            INVOICE DETAILS
                          </th>
                          <th colSpan="2" class="sub-header">
                            PAYMENT DETAILS
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th class="sub-header" style={{ width: "50px" }}>
                            ##
                          </th>
                          <th
                            title="Employee Name"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Emp. Name
                          </th>
                          <th
                            title="Day Count"
                            class="sub-header"
                            style={{ width: "70px" }}
                          >
                            Day Count
                          </th>
                          <th
                            title="Invoice Days"
                            class="sub-header"
                            style={{ width: "70px" }}
                          >
                            Inv. Days
                          </th>
                          <th
                            title="Rate/Frequency"
                            class="sub-header"
                            style={{ width: "100px" }}
                          >
                            Rate/Freq
                          </th>
                          <th
                            title="From Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            From Dt.
                          </th>
                          <th
                            title="To Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            To Dt.
                          </th>
                          <th
                            title="Basic Amount"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Basic Amt
                          </th>
                          <th
                            title="Adjustment Amount"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Adj. Amt.
                          </th>
                          <th
                            title="Proforma Amount"
                            class="sub-header"
                            style={{ width: "100px" }}
                          >
                            Proforma Amt.
                          </th>
                          <th
                            title="Tax %"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Tax %
                          </th>
                          <th
                            title="Exchange Rate"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Exc. Rate<span className="text-danger">*</span>
                          </th>
                          <th
                            title="Invoice Amount"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Invoice Amt.
                          </th>
                          <th
                            title="Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Date
                          </th>
                          <th
                            title="Number"
                            className="required"
                            class="sub-header"
                            style={{ width: "50px" }}
                          >
                            No.<span className="text-danger">*</span>
                          </th>
                          <th
                            title="Term Days"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Term Days
                          </th>
                          <th
                            title="Due Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Due Dt.
                          </th>
                          {/* <th
                            title="Follow-up Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Follow-up Dt.
                          </th>
                          <th
                            title="Received Date"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Recd. dt.
                          </th> */}
                          {/* <th
                            title="Overdue"
                            class="sub-header"
                            style={{ width: "80px" }}
                          >
                            Overdue
                          </th> */}
                          <th
                            title="Remarks"
                            class="sub-header"
                            style={{ width: "120px" }}
                          >
                            Remarks
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={21} className="text-center py-4">
                              <div className="d-flex justify-content-center">
                                <FaSpinner className="spinner" />
                              </div>
                              <div className="text-muted mt-2">Loading</div>
                            </td>
                          </tr>
                        ) : Object.keys(filteredEntries).length === 0 ? (
                          <tr>
                            <td
                              colSpan={21}
                              className="text-center text-muted py-3"
                            >
                              No Record Found
                            </td>
                          </tr>
                        ) : (
                          filteredEntries.map((line, index) => (
                            <React.Fragment key={index}>
                              {(index === 0 ||
                                line.tmpClientName !==
                                filteredEntries[index - 1].tmpClientName) && (
                                  <tr>
                                    <td
                                      colSpan="20"
                                      title={
                                        line.tmpClientMSANo
                                          ? `(${line.tmpClientMSANo}: ${moment(
                                            line.tmpClientStartDate
                                          ).format("DD-MMM-YYYY")}  - ${moment(
                                            line.tmpClientEndDate
                                          ).format("DD-MMM-YYYY")})`
                                          : ""
                                      }
                                    >
                                      <b>{line.tmpClientName}</b>
                                      {line.tmpClientMSANo
                                        ? `(MSA Ref: ${line.tmpClientMSANo
                                        } ${moment(
                                          line.tmpClientStartDate
                                        ).format("DD-MMM-YYYY")} - ${moment(
                                          line.tmpClientEndDate
                                        ).format("DD-MMM-YYYY")})`
                                        : ""}
                                    </td>
                                  </tr>
                                )}

                              {/* Show project header only if it's the first entry or project changed */}
                              {(index === 0 ||
                                line.tmpProjectName !==
                                filteredEntries[index - 1].tmpProjectName ||
                                line.tmpClientName !==
                                filteredEntries[index - 1].tmpClientName) && (
                                  <tr className={parentClass(line)}>
                                    <td
                                      style={{
                                        backgroundColor: "#DBEAC8",
                                        color: "black",
                                      }}
                                      colSpan="21"
                                      title={
                                        line.tmpProjectInvoiceDetailNumber
                                          ? `(${line.tmpProjectInvoiceDetailNumber
                                          }: ${moment(line.StartDate).format(
                                            "DD-MMM-YYYY"
                                          )} - ${moment(line.EndDate).format(
                                            "DD-MMM-YYYY"
                                          )})`
                                          : ""
                                      }
                                      className={
                                        isFixedBid(line)
                                          ? "info"
                                          : isConsolidated(line)
                                            ? "consldt-bg-color"
                                            : ""
                                      }
                                    >
                                      <b>{line.tmpProjectName}</b>
                                      {line.tmpProjectInvoiceDetailNumber
                                        ? `(SOW/PO/SO: ${line.tmpProjectInvoiceDetailNumber
                                        } ${moment(line.StartDate).format(
                                          "DD-MMM-YYYY"
                                        )} - ${moment(line.EndDate).format(
                                          "DD-MMM-YYYY"
                                        )})`
                                        : ""}
                                    </td>
                                  </tr>
                                )}
                              <tr className={leafParentClass(line)}>
                                <td style={{ width: "40px" }}>
                                  <input
                                    type="checkbox"
                                    className="IsConfirmed"
                                    checked={line.IsConfirmed || false}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "IsConfirmed",
                                        e.target.checked
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled
                                    value={line.tmpEmployeeName}
                                    title={line.tmpEmployeeName}
                                    style={{ width: "120px" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={line.DayCount}
                                    title={line.DayCount}
                                    disabled
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "DayCount",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: "70px", textAlign: "end" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    value={line.InvoicedDays}
                                    title={line.InvoicedDays}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "InvoicedDays",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: "70px", textAlign: "end" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    style={{ width: "120px" }}
                                    disabled
                                    value={line.tmpInvoiceRateFreq}
                                    title={line.tmpInvoiceRateFreq}
                                  />
                                </td>
                                <td>
                                  <input
                                    style={{
                                      width: "120px",
                                      textAlign: "center",
                                    }}
                                    disabled
                                    value={moment(line.InvoiceFromDate).format(
                                      "DD-MMM-YYYY"
                                    )}
                                    title={line.InvoiceFromDate}
                                  />
                                </td>
                                <td>
                                  <input
                                    style={{
                                      width: "120px",
                                      textAlign: "center",
                                    }}
                                    disabled
                                    value={moment(line.InvoiceToDate).format(
                                      "DD-MMM-YYYY"
                                    )}
                                    title={line.InvoiceToDate}
                                  />
                                </td>
                                <td className="numberColumn">
                                  <input
                                    style={{ width: "80px", textAlign: "end" }}
                                    value={
                                      line.tmpCurrencySymbol +
                                      " " +
                                      line.BasicAmount
                                    }
                                    title={
                                      line.tmpCurrencySymbol +
                                      " " +
                                      line.BasicAmount
                                    }
                                    disabled
                                  />
                                </td>
                                <td className="numberColumn">
                                  <input
                                    type="number"
                                    style={{ width: "80px", textAlign: "end" }}
                                    value={line.AdjustmentAmount}
                                    title={line.AdjustmentAmount}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "AdjustmentAmount",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="numberColumn">
                                  <input
                                    type="number"
                                    style={{ width: "100px", textAlign: "end" }}
                                    value={line.InvoicedAmount}
                                    title={line.InvoicedAmount}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "InvoicedAmount",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    style={{ width: "80px", textAlign: "end" }}
                                    value={line.TaxPercent}
                                    title={line.TaxPercent}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "TaxPercent",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    style={{ width: "80px", textAlign: "end" }}
                                    value={line.ExchangeRate}
                                    title={line.ExchangeRate}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "ExchangeRate",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="numberColumn">
                                  <input
                                    type="number"
                                    disabled
                                    style={{ width: "80px", textAlign: "end" }}
                                    value={line.InvoiceCalculatedAmount}
                                    title={line.InvoiceCalculatedAmount}
                                  />
                                </td>
                                <td
                                  style={{
                                    width: "120px",
                                    textAlign: "center",
                                  }}
                                >
                                  <DatePicker
                                    selected={
                                      line.InvoiceDate
                                        ? moment(
                                          line.InvoiceDate,
                                          "DD-MMM-YYYY"
                                        ).toDate()
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleLineChange(
                                        index,
                                        "InvoiceDate",
                                        moment(date).format("DD-MMM-YYYY")
                                      )
                                    }
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Invoice Date"
                                  />
                                </td>
                                <td>
                                  <input
                                    value={line.InvoiceNo}
                                    title={line.InvoiceNo}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "InvoiceNo",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: "80px", textAlign: "end" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    disabled
                                    value={line.PaymentTermDays}
                                    title={line.PaymentTermDays}
                                    style={{ width: "80px", textAlign: "end" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled
                                    value={moment(line.PaymentDueDate).format(
                                      "DD-MMM-YYYY"
                                    )}
                                    title={line.PaymentDueDate}
                                    style={{
                                      width: "120px",
                                      textAlign: "center",
                                    }}
                                  />
                                </td>
                                {/* <td style={{ width: "120px" }}>
                                  <DatePicker
                                    selected={
                                      line.FollowUpDate
                                        ? moment(
                                          line.FollowUpDate,
                                          "DD-MMM-YYYY"
                                        ).toDate()
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleLineChange(
                                        index,
                                        "FollowUpDate",
                                        moment(date).format("DD-MMM-YYYY")
                                      )
                                    }
                                    dateFormat="dd-MMM-yyyy"
                                    placeholderText="FollowUp Date"
                                    customInput={
                                      <CustomDatePickerInput width="120px" />
                                    }
                                  />
                                </td>
                                <td>
                                  <DatePicker
                                    selected={
                                      line.PaymentReceivedDate
                                        ? moment(
                                          line.PaymentReceivedDate,
                                          "DD-MMM-YYYY"
                                        ).toDate()
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleLineChange(
                                        index,
                                        "PaymentReceivedDate",
                                        moment(date).format("DD-MMM-YYYY")
                                      )
                                    }
                                    dateFormat="dd-MMM-yyyy"
                                    placeholderText="PaymentReceived Date"
                                    customInput={
                                      <CustomDatePickerInput width="120px" />
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    disabled
                                    value={line.OverDueDays}
                                    title={line.OverDueDays}
                                    style={{ width: "80px", textAlign: "end" }}
                                  />
                                </td> */}
                                <td>
                                  <input
                                    value={line.Remarks}
                                    onChange={(e) =>
                                      handleLineChange(
                                        index,
                                        "Remarks",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: "120px" }}
                                  />
                                </td>
                              </tr>
                            </React.Fragment>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default InvoiceListTraining;
